import React, { FC, useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@material-ui/core';

interface AssessmentTemplateGroupDialogProps {
    open: boolean;
    initialName: string;
    isEditing: boolean;
    onSubmit: (name: string) => void;
    onClose: () => void;
}

const AssessmentTemplateGroupDialog: FC<AssessmentTemplateGroupDialogProps> = ({
    open,
    initialName,
    isEditing,
    onSubmit,
    onClose
}) => {
    const [name, setName] = useState(initialName);

    useEffect(() => {
        if (open) {
            setName(initialName);
        }
    }, [initialName, open]);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (!name.trim()) {
            return;
        }
        onSubmit(name.trim());
    };

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="group-dialog-title" fullWidth maxWidth="sm">
            <form onSubmit={handleSubmit}>
                <DialogTitle id="group-dialog-title">{isEditing ? 'Edit group' : 'Add group'}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        label="Group name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        margin="dense"
                        fullWidth
                        required
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" variant="contained">
                        {isEditing ? 'Save' : 'Create'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default AssessmentTemplateGroupDialog;
